import api from "../api";

export interface ServiceFeeResponse {
  serviceChargeAmountCents: number;
  serviceChargePaidBy: string;
}

export const fetchServiceFee = async (): Promise<ServiceFeeResponse> => {
  const response = await api.get<ServiceFeeResponse>("/Employer/service-fee");
  return response.data;
};
